import { useEffect, useState } from "react";
import { Body, SectionHeader } from "@sprout/typography";
import Container from "@components/ui/container";
import BackButton from "@components/back_button.tsx";
import { Checkbox } from "@/sprout/checkbox";

import useTranslation from "@hooks/use_translation";
import useProfile from "@/queries/use_profile";
import { useShowFlash } from "@sprout/flash.tsx";
import axios, { isAxiosError } from "axios";

const DoNotShare = () => {
  const { t } = useTranslation("user");
  const showFlash = useShowFlash();
  const { data } = useProfile();

  const [checked, setChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (data) {
      setChecked(Boolean(data.doNotSell));
    }
  }, [data]);

  const handleChange = async (next: boolean) => {
    if (!data?.paths.doNotSharePath) {
      return;
    }

    setChecked(next);
    setSubmitting(true);

    try {
      await axios.post(data.paths.doNotSharePath, { opted_out: next });
    } catch (err) {
      setChecked(!next);
      if (isAxiosError(err) && err.response?.status === 429) {
        showFlash(t("doNotShare.tooManyAttempts"), "error");
      } else {
        showFlash(t("doNotShare.error"), "error");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container>
      <BackButton href="/account" />

      <div className="flex flex-col gap-4">
        <SectionHeader as="h1">{t("doNotShare.title")}</SectionHeader>
        <Body>{t("doNotShare.subtitle")}</Body>
      </div>
      <div className="flex flex-col gap-3">
        <Checkbox
          id="do_not_share"
          options={[{ value: "1", label: t("doNotShare.checkboxLabel") }]}
          onSelect={() => handleChange(!checked)}
          values={checked ? ["1"] : []}
          disabled={submitting}
          isMulti
        />
      </div>
    </Container>
  );
};

export default DoNotShare;
